import { render, staticRenderFns } from "./ActDesc.vue?vue&type=template&id=1f726ed1&scoped=true&"
import script from "./ActDesc.vue?vue&type=script&lang=ts&"
export * from "./ActDesc.vue?vue&type=script&lang=ts&"
import style0 from "./ActDesc.vue?vue&type=style&index=0&id=1f726ed1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f726ed1",
  null
  
)

export default component.exports